import { apiCrm } from '../http';

class AddressService {
  createAddress(data) {
    return apiCrm.post('/address', data);
  }

  removeAddress(addressId) {
    return apiCrm.delete(`/address/${addressId}`);
  }

  updateAddress(addressId, data) {
    return apiCrm.put(`/address/${addressId}`, data);
  }
}

export default new AddressService();
